import Slider from 'rc-slider';
import { FC } from 'react';

const RANGE_STYLE = {
  dotStyle: { borderColor: '#ccc' },
  railStyle: { backgroundColor: '#ccc' },
  activeDotStyle: { borderColor: 'black' },
  trackStyle: [{ backgroundColor: 'black' }, { backgroundColor: 'black' }],
  handleStyle: [
    { backgroundColor: 'white', borderColor: 'black' },
    { backgroundColor: 'white', borderColor: 'black' },
  ],
};

const MARK_STYLE = { fontWeight: 'bold', background: 'white', padding: '0 0.2em', zIndex: 1 };

const DateSelector: FC<{
  date: number;
  min: number;
  max: number;
  onChange: (v: number) => void;
}> = ({ date, min, max, onChange }) => {
  return (
    <Slider
      range
      vertical={true}
      value={date}
      min={min}
      max={max}
      step={1}
      marks={{
        [min]: {
          label: min,
          style: MARK_STYLE,
        },
        [max]: {
          label: max,
          style: MARK_STYLE,
        },
        [date]: {
          label: date,
          style: MARK_STYLE,
        },
      }}
      onChange={(value) => onChange(Array.isArray(value) ? value[0] : value)}
      {...RANGE_STYLE}
    />
  );
};

export default DateSelector;
